// extracted by mini-css-extract-plugin
export default {"couponListCard":"CouponListCard_couponListCard__MaqX8","productImg":"CouponListCard_productImg__Y6n44"};